import { Component, OnInit, ViewChild, ElementRef, Input } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';
import { CountriesDataService } from '../services/countriesData.service';
import { NgForm } from '@angular/forms';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { MatSort } from '@angular/material/sort';
import { Country } from '../models/country';
import { TestLock } from '../models/testLock';
import { AuthService } from '../services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { LockType } from '../models/lockType';
import { HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';
import { Router } from '@angular/router';
import { ReqGenerateCryptoKeys } from '../models/reqGenerateCryptoKeys';
import { ReqExportCryptoKeys } from '../models/reqExportCryptoKeys';
declare var require: any;

@Component({
  selector: 'app-countiesData',
  templateUrl: './countriesData.component.html'
})
export class CountriesDataComponent implements OnInit {

  lockTypeIdList: LockType[] = [];
  selectedLockTypeId: number;

  countryList: Country[] = [];
    selectedCountry: number;


    constructor(private router: Router,private translate: TranslateService, public service: CountriesDataService, private toastr: ToastrService, private authService: AuthService, private spinner: NgxSpinnerService)
  {
    
  }

  displayedColumnsCountries: string[] = ['select', 'id', 'name', 'code', 'version','lastTest'];
  displayedColumnsTestLocks: string[] = ['lockID', 'lockTypeID', 'lockTypeName', 'serialNumber', 'lockOrAsset', 'comment', 'disabled','actions'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSourceCountries = new MatTableDataSource<Country>();
  dataSourceTestLocks = new MatTableDataSource<TestLock>();
  filterValues: any = {};
  selection = new SelectionModel<Country>(true, []);
  isLoading = true;
  selectedRowIndex: any;
  readonly = false;
    chkSeeds = true;
    chkLocks = true;
  testLock = new TestLock();
  isCountrySelected: boolean = false;
  newOrEdit: boolean = false;


  ngOnInit() {
    this.fillKeysInfoGrid();

    this.service.getLockTypes().subscribe(data => { this.lockTypeIdList = data }, error => console.log(error));
  }

  fillKeysInfoGrid() {
    this.spinner.show();
    this.isLoading = true;
    this.service.getCountriesList().subscribe(
      res => {
        this.isLoading = false;         
        this.countryList = res;
        this.dataSourceCountries = new MatTableDataSource<Country>();
        this.dataSourceCountries.data = res as [];
        this.dataSourceCountries.sort = this.sort;
        this.dataSourceCountries.paginator = this.paginator;
        this.dataSourceCountries.paginator._intl.itemsPerPageLabel = this.translate.instant("REG.ITEMS_PER_PAGE");
        this.spinner.hide();
      },
      err => {
        this.selection = new SelectionModel<Country>(true, []);
        this.spinner.hide();
      });
  }

  generate() {
    this.spinner.show();
    var req = new ReqGenerateCryptoKeys();
    req.logUser = this.authService.getLoginFromToken();

    let selectedIds: string[] = [];
    for (let item of this.selection.selected) {
      selectedIds.push(item.id.toString());
    }
    req.id = selectedIds;

    this.service.generateCryptoKeys(req).subscribe(
      res => {
        this.dataSourceCountries.data = res as [];
        this.toastr.success('Ok.', this.translate.instant("ACTIVATION.CONTINGENCY_ACTIVATION"))
        this.selection = new SelectionModel<Country>(true, []);
        this.spinner.hide();
      },
      err => {
        this.selection = new SelectionModel<Country>(true, []);
        this.spinner.hide();
      }
      
    );
  }

  upload(files) {
    let user = this.authService.getLoginFromToken();
 
    if (files.length === 0)
      return;
    const formData = new FormData();
    for (let file of files)
      formData.append(file.name, file);
      this.service.uploadCryptoKeys(formData, user).subscribe(
          event => {
              if (event.type === HttpEventType.Response)
                  this.fillKeysInfoGrid();
              this.toastr.success(this.translate.instant("ADMIN.UPLOAD") + " " + this.translate.instant("COM.SUCCESSFUL"), '');
          }); 
  }


  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSourceCountries.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSourceCountries.data.forEach(row => this.selection.select(row));
  }


  /** The label for the checkbox on the passed row */
  //checkboxLabel(row?: CountryData): string {
  //  if (!row) {
  //    return "${this.isAllSelected() ? 'select' : 'deselect'} all";
  //  }
  //  return "${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.id + 1}";
  //}

    selectCountryRow(id) {
    this.isCountrySelected = true;
    this.newOrEdit = false;
    this.selectedRowIndex = id;
    this.selectedCountry = Number(id);
    this.spinner.show();
    this.service.getTestLocks(id).subscribe(
      res => {
        this.dataSourceTestLocks = new MatTableDataSource<TestLock>();
        this.dataSourceTestLocks.data = res as [];
        this.spinner.hide();
        
      },
      err => {
        this.spinner.hide();
      });

  }

  onSubmit(form: NgForm) {
    this.spinner.show();
    form.value.logUser = this.authService.getLoginFromToken();
      form.value.countryID = this.selectedCountry;
      form.value.lockTypeID = this.selectedLockTypeId;
      form.value.editMode = ((form.value.editMode == null) ? false : form.value.editMode);
    this.service.saveLock(form.value).subscribe(
      res => {
        this.resetForm(form);
        this.readonly = false;
            this.toastr.success(this.translate.instant("COM.true"), '');
          this.selectCountryRow(this.selectedCountry);
        this.spinner.hide();
      },
      err => {        
          this.spinner.hide();
          
      }
    )


  }

    resetForm(form: NgForm) {
        form.resetForm();
        this.newOrEdit = false;
        this.readonly = false;
        this.countryList = this.dataSourceCountries.data;
        if (this.selectedCountry != undefined) {
            this.selectCountryRow(this.selectedCountry);
        } 
    }

    newRow() {
        this.newOrEdit = true;
    }

  editRow(item) {
    window.scrollTo(0, document.body.scrollHeight);
     // this.testLock = item;
      let selectedItem = JSON.parse(JSON.stringify(item));
      this.testLock = selectedItem;
      this.newOrEdit = true;
    this.selectedLockTypeId = item.lockTypeID;
    //this.testLock.logUser = this.authService.getLoginFromToken();
      this.testLock.editMode = true;
    this.readonly = true;
  }

  delteRow(item: TestLock) {
    this.spinner.show();
    item.logUser = this.authService.getLoginFromToken();

    this.service.deleteLock(item).subscribe(
      res => {
        this.selectCountryRow(this.selectedCountry);
        this.spinner.hide();
        this.toastr.success(this.translate.instant("COM.true"), '')
      },
      err => {
        this.spinner.hide();        
          
      }
    );
  }

  recoverRow(item: TestLock) {
    this.spinner.show();
    item.logUser = this.authService.getLoginFromToken();

    this.service.recoverLock(item).subscribe(
      res => {
        this.selectCountryRow(this.selectedCountry);
        this.spinner.hide();
        this.toastr.success(this.translate.instant("COM.true"), '')
      },
      err => {
        this.spinner.hide();        
          
      }
    );
  }

  export() {
    this.spinner.show();

    let req = new ReqExportCryptoKeys();

    req.path = "PK_Seeds_.dat";
    req.logUser = this.authService.getLoginFromToken();

    let selectedIds: string[] = [];
    for (let item of this.selection.selected) {
      selectedIds.push(item.id.toString());
    }
    req.countryId = selectedIds;

    req.includeKeys = this.chkSeeds
    req.includeLocks = this.chkLocks


    this.service.exportCryptoKeys(req).subscribe(
      res => {
        this.spinner.hide();
            var FileSaver = require('file-saver');
            let date = new Date();
            let file = "Seeds-" + date.toISOString() + ".zip";
            FileSaver.saveAs(res, file);
            this.toastr.success(this.translate.instant("COM.true"), '')
      },
      err => {
        this.spinner.hide();        
           
      }
    );
  }

  //ExportAudit() {
  //  this.spinner.show();
  //  return this.adminService.ExportAudit(this.startDate, this.endDate)
  //    .subscribe((result: any) => {
  //      if (result.type != 'text/plain') {
  //        var blob = new Blob([result]);
  //        let saveAs = require('file-saver');
  //        let file = "Audit.xlsx";
  //        saveAs(blob, file);
  //        this.spinner.hide()
  //        this.toastr.success("", this.translate.instant("ADMIN.DOWNLOAD") + " " + this.translate.instant("COM.SUCCESSFUL"))
  //      }
  //    },
  //      err => {
  //        this.spinner.hide()
  //        this.toastr.error(this.translate.instant(err.error), this.translate.instant("COM.ERROR"));
  //      }
  //    );
  //}


}
